import { U_KEY, U_NAME, U_POSITION } from '@app/constants';
import type { NEmployees } from '@app/types/Employees';

export const adaptDataToTable = (
  data: NEmployees.ModelEmployeeOrderForFront[]
) => {
  return data?.map((employee: NEmployees.ModelEmployeeOrderForFront) => {
    const { Position, Employee, Key } = employee;

    return {
      [U_KEY]: String(Key),
      [U_NAME]: (
        <div style={{ minWidth: '75px' }} data-testid="employee-name">
          {Employee}
        </div>
      ),
      [U_POSITION]: (
        <div style={{ minWidth: '75px' }} data-testid="employee-position">
          {Position}
        </div>
      ),
    };
  });
};
